import { useContext } from 'react';
import { TransitionGroup } from 'react-transition-group';
import { StoreContext } from '@provider/notifier';
import { useObservedValue, CSSRefTransition } from '@utils/react';
import { dialogSelectors, dialogTransitionDurationMs } from '../components/overlays/dialog.style.js';
import { Dialog } from './molecule.dialog.js';
import { jsx } from 'react/jsx-runtime';

function DialogContainer() {
  const store = useContext(StoreContext);
  const dialogs = useObservedValue(store.refs.dialogs).filter(it => !it.type);
  return /*#__PURE__*/jsx(TransitionGroup, {
    component: null,
    children: dialogs.map(dialog => /*#__PURE__*/jsx(CSSRefTransition, {
      timeout: dialogTransitionDurationMs,
      classNames: dialogSelectors.wrapper.className,
      children: ref => /*#__PURE__*/jsx(Dialog, {
        ref: ref,
        model: dialog
      })
    }, dialog.id))
  });
}

export { DialogContainer };
//# sourceMappingURL=organism.dialog-container.js.map
